import { Link } from "react-router-dom";

import { PageContainer } from "@/components/core/page-container";
import { Seo } from "@/components/seo/seo";
import { buttonVariants } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { useLocale } from "@/i18n/locale-context";

export function NotFoundPage(): JSX.Element {
  const { locale, localePath, t } = useLocale();

  return (
    <>
      <Seo
        description={t("errors.notFoundIntro")}
        locale={locale}
        noindex
        pathWithoutLocale="/404"
        title="404"
      />
      <section className="py-16 md:py-24">
        <PageContainer>
          <Card className="space-y-6">
            <p className="eyebrow text-primary">404</p>
            <h1 className="text-xl md:text-2xl">{t("errors.notFoundTitle")}</h1>
            <p className="max-w-2xl leading-7 text-muted-foreground">
              {t("errors.notFoundIntro")}
            </p>
            <div>
              <Link
                className={buttonVariants({ variant: "outline" })}
                to={localePath("/")}
              >
                {t("actions.backToHome")}
              </Link>
            </div>
          </Card>
        </PageContainer>
      </section>
    </>
  );
}
